import { AreaGroup } from './area-group'
import { Banner } from './banner'
import { CustomMenu } from './custom-menu'
import { SitemapItem } from './sitemap-item'

export class Sitemap extends SitemapItem {
  public name: string
  public context: string
  public areas: AreaGroup[]
  public banner: Banner
  public subBanner: Banner
  public customMenu: CustomMenu
  public bottomCustomMenu: CustomMenu

  constructor(model: Sitemap) {
    super(model)
    this.name = model.name
    this.context = model.context
    this.areas = model.areas ? this.mapAreaGroups(model.areas) : []
    this.banner = model.banner
    this.subBanner = model.subBanner
    this.customMenu = model.customMenu
    this.bottomCustomMenu = model.bottomCustomMenu
  }

  public merge(model: Sitemap): void {
    model.areas.forEach((a) => {
      const area = this.areas.find((ar) => ar.id == a.id)
      if (area) {
        area.merge(a)
      } else {
        this.areas.push(new AreaGroup(a))
      }
    })
  }

  private mapAreaGroups(areaGroups: AreaGroup[]): AreaGroup[] {
    const mapped: AreaGroup[] = []
    if (areaGroups) {
      areaGroups.forEach((a) => mapped.push(new AreaGroup(a)))
    }
    return mapped
  }
}
